import React, { useEffect, useState, useRef } from 'react';
import './manageRecurringEmailsPopUp.scss';
import profileState from 'Stores/profile';
import { ReactComponent as CrossIcon } from 'Assets/usageAnalytics/cross-icon.svg';
import { ReactComponent as DltCrossIcon } from 'Assets/usageAnalytics/dlt-cross-icon.svg';
import { ReactComponent as ThreeDotsIcon } from 'Assets/usageAnalytics/three-dots-icon.svg';
import { LoadingWrapper } from 'Components/common/loadingWrapper';
import { toasterState } from 'Components/common/toaster';
import Dropdown from 'Components/common/dropdown';
import * as CONSTANTS from 'Utils/constants';
import Utils from 'Utils/utils';

const ManageRecurringEmails = props => {
  const { onClose, openRecurringEmail, deletePopRef } = props;
  const [listOfSchedules, setListOfSchedules] = useState([]);
  const [apiCalled, setApiCalled] = useState(false);
  const [editPopUp, setEditPopUp] = useState(false);
  const [clickedIndex, setClickedIndex] = useState(null);
  const [deletePopUp, setDeletePopUp] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [clickedIndexForMore, setClickedIndexForMore] = useState([]);
  const manageEmailToolTipRef = useRef();

  const getRecurringEmails = async () => {
    setIsLoading(true);
    const response = await profileState.getTheRecurringEmails();
    if (response.status === 200) {
      const data = response.data?.map(ele => {
        const { id, name, recepients, time, timeZone } = ele;
        let { frequency, day, ordinalDay } = ele;
        frequency = frequency.toLowerCase();
        ordinalDay = ordinalDay?.toLowerCase();
        day = day.toLowerCase();
        return {
          id,
          name,
          day,
          frequency,
          recepients,
          ordinalDay,
          time,
          timeZone,
        };
      });
      setListOfSchedules(data);
    }
    setApiCalled(true);
    setIsLoading(false);
  };

  useEffect(() => {
    getRecurringEmails();
  }, []);

  const handleOnClickDeleteMail = async () => {
    setIsLoading(true);
    const response = await profileState.deleteRecurringMail(
      listOfSchedules[clickedIndex].id,
    );
    if (response.status === 200) {
      Utils.mixpanelTrack(CONSTANTS.MX_EMAIL_DIGEST_EVENTS.EMAIL_DIGEST_DELETE);
      getRecurringEmails();
      setDeletePopUp(false);
      setEditPopUp(false);
      toasterState.setToastMsg(
        `${listOfSchedules[clickedIndex].name} is deleted successfully.`,
        'success',
        { className: 'isUsageAnalyticsMessage' },
      );
    } else {
      toasterState.setToastMsg(
        'Error while deleting the email digest',
        'failure',
      );
      setIsLoading(false);
      setDeletePopUp(false);
      setEditPopUp(false);
    }
  };

  const handleToolTipClickOutside = event => {
    if (
      manageEmailToolTipRef &&
      !manageEmailToolTipRef?.current?.contains(event.target) &&
      editPopUp
    )
      setEditPopUp(false);
  };

  useEffect(() => {
    if (editPopUp) {
      // eslint-disable-next-line no-undef
      document.addEventListener('click', handleToolTipClickOutside, true);
      return () =>
        // eslint-disable-next-line no-undef
        document.removeEventListener('click', handleToolTipClickOutside, true);
    }
    return undefined;
  }, [editPopUp]);
  return (
    <div className="manage-emails-wrapper">
      <div className="EmailContainer manage-email-digest-height">
        <LoadingWrapper position="fixed" show={isLoading} />
        <div className="header-container manage-email-digest">
          <h4>Manage Email Digest</h4>
          <div>
            <CrossIcon onClick={() => onClose('')} />
          </div>
        </div>
        <div className="list-of-scheduled-container">
          <span>List of scheduled emails</span>
          <button
            type="button"
            onClick={() => {
              setClickedIndex(null);
              openRecurringEmail(null, true);
            }}
          >
            <span>+</span>
            <span>Create Email Digest</span>
          </button>
        </div>
        <div className="list-container">
          <ul className="list-of-recipients-headers">
            <li>Name </li>
            <li>Scheduled On</li>
            <li>Time</li>
            <li>Recipients</li>
          </ul>
          <div>
            {apiCalled === true &&
              listOfSchedules.length > 0 &&
              listOfSchedules?.map((ele, i) => {
                return (
                  <ul className="list-of-scheduled-content" key={i}>
                    <li>{ele.name}</li>
                    {ele.frequency === 'WEEKLY' ? (
                      <li>
                        <span>{ele.frequency}</span>
                        <span>on</span>
                        <span>{ele.day}</span>
                      </li>
                    ) : (
                      <li>
                        <span>{ele.frequency}</span>
                        <span>on</span>
                        <span>{ele.ordinalDay}</span>
                        <span>{ele.day}</span>
                      </li>
                    )}
                    <li>
                      {ele.time} ({ele.timeZone})
                    </li>
                    <li>
                      {ele?.recepients?.length <= 2 &&
                        ele?.recepients?.map((mail, index) => {
                          return <span key={index}>{mail}</span>;
                        })}
                      {ele?.recepients?.length > 2 &&
                        !clickedIndexForMore.includes(i) &&
                        ele?.recepients?.slice(0, 2).map((mail, index) => {
                          return <span key={index}>{mail}</span>;
                        })}
                      {ele?.recepients?.length > 2 &&
                        clickedIndexForMore.includes(i) &&
                        ele?.recepients?.map((mail, index) => {
                          return <span key={index}>{mail}</span>;
                        })}
                      {ele?.recepients?.length > 2 &&
                        !clickedIndexForMore.includes(i) && (
                          <span
                            className="more-icon"
                            onClick={() => {
                              const indexArray = clickedIndexForMore;
                              indexArray.push(i);
                              setClickedIndexForMore([...indexArray]);
                            }}
                          >
                            + {ele.recepients.length - 2} more
                          </span>
                        )}
                    </li>
                    <li>
                      <Dropdown toggleElement={<ThreeDotsIcon />} align="end">
                        <div
                          className="manage-emails-tool-tip"
                          ref={manageEmailToolTipRef}
                        >
                          <p
                            onClick={() => {
                              openRecurringEmail(listOfSchedules[i].id, false);
                            }}
                            aria-hidden="true"
                          >
                            Edit
                          </p>
                          <p
                            aria-hidden="true"
                            onClick={() => {
                              setDeletePopUp(!deletePopUp);
                              setClickedIndex(i);
                              setEditPopUp(false);
                            }}
                          >
                            Delete
                          </p>
                        </div>
                      </Dropdown>
                    </li>
                  </ul>
                );
              })}
            {apiCalled === true && listOfSchedules.length === 0 && (
              <div className="no-digest-mails-text">
                You do not have any scheduled emails. <br /> Create your first
                email digest by clicking on <q>Create Email Digest</q>
              </div>
            )}
          </div>
        </div>
        {deletePopUp === true && (
          <div className="delete-emails-wrapper">
            <div className="delete-container" ref={deletePopRef}>
              <LoadingWrapper position="fixed" show={isLoading} />
              <div className="dltPopUp">
                <div className="dltHeader">
                  <h4>Delete Email Digest</h4>
                  <DltCrossIcon
                    onClick={() => {
                      setDeletePopUp(!deletePopUp);
                    }}
                    aria-hidden="true"
                    alt="cross icon-"
                  />
                </div>
                <div className="headerMargin" />
                <div className="infoContainer">
                  <p>
                    On deleting <b>“{listOfSchedules[clickedIndex].name}”</b>{' '}
                    email digest, the users added to this will no longer be
                    notified with any of the credit usage updates.
                  </p>
                  <p className="question">Are you sure you want to delete?</p>
                </div>
                <div className="delete-buttons">
                  <button
                    className="new-button"
                    type="button"
                    onClick={handleOnClickDeleteMail}
                  >
                    Delete
                  </button>
                  <button
                    className="new-green-button"
                    type="button"
                    onClick={() => {
                      setDeletePopUp(!deletePopUp);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
            <div
              className="common-popup-mask common-back-ground"
              onClick={() => {
                setDeletePopUp(!deletePopUp);
              }}
            />
          </div>
        )}
      </div>
      <div
        className="common-popup-mask common-back-ground"
        onClick={() => onClose('', '')}
      />
    </div>
  );
};
export default ManageRecurringEmails;
